module.exports = __webpack_public_path__ + "static/img/lunbo3.b43ccbd1.png";